


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ILayerDef } from '@/modules/design/interfaces/shared';

import { UnitSystem } from '@/interfaces/units';
import { designStore } from '@/store/store';
import { imperialPrecision, metricPrecision } from '@/main';


@Component
export default class GenericPavementDiagram extends Vue {
  @Prop({}) layers!: ILayerDef[];

  // inchesToLineHeightFactor = 0.75;
  inchesToPxFactor= 22 ;//* this.thicknessMultiplier;

  defaultLayerThickness = this.unitSystemIsImperial ? 2 : 2 * 2.54; // In

  get thicknessMultiplier() {
    const t = this.unitSystemIsImperial ? 1 : 2.54;
    // console.log('changing thickness', t);
    return t;
  }

  get scenarioImperial() {
    return designStore.currentScenarioImperial;
  }

  get displayPrecision() {
    return this.unitSystemIsImperial ? imperialPrecision : metricPrecision;
  }

  get unitSystemIsImperial() {
    return designStore.displayUnits === UnitSystem.Imperial;
    // if (this.scenarioImperial){
    //   return this.scenarioImperial.unitSystem === UnitSystem.Imperial;
    // } else {
    //   console.debug('No scenario in pavement diagram');
    //   return true
    // }
  }

  mounted() {
    // console.log('Diagram', this.thicknessMultiplier);
  }
}
